import { useState } from 'react';
import PropTypes from 'prop-types';

const getPortalUrl = (accessToken) => `${window.location.origin}/portal?token=${accessToken}`;

// Shows the portal link and PIN right after they are generated. The backend
// only stores digests, so this is the only moment they can be read.
export default function PortalAccessCredentials({ accessToken, accessPin }) {
  const [copied, setCopied] = useState(null);
  const portalUrl = getPortalUrl(accessToken);

  const copy = async (value, key) => {
    try {
      await navigator.clipboard.writeText(value);
      setCopied(key);
      setTimeout(() => setCopied(null), 2000);
    } catch (error) {
      console.error('Error copying to clipboard:', error);
    }
  };

  const rows = [
    { key: 'url', label: 'Enlace del portal', value: portalUrl, mono: 'text-xs' },
    { key: 'pin', label: 'PIN de acceso', value: accessPin, mono: 'text-2xl font-bold tracking-widest' },
  ];

  return (
    <div className="flex flex-col gap-3 p-3 rounded-lg border border-amber-300 bg-amber-50 dark:bg-amber-900/20 dark:border-amber-700">
      <p className="text-xs font-medium text-amber-800 dark:text-amber-300">
        Copia el enlace y el PIN ahora: no se vuelven a mostrar. Si se pierden, genera un acceso nuevo.
      </p>
      {rows.map((row) => (
        <div key={row.key}>
          <span className="block mb-1 text-xs text-gray-600 dark:text-gray-400">{row.label}</span>
          <div className="flex items-center gap-2">
            <code
              className={`flex-1 min-w-0 truncate px-3 py-2 rounded-md bg-white dark:bg-gray-800 font-mono text-gray-800 dark:text-gray-200 ${row.mono}`}
            >
              {row.value}
            </code>
            <button
              type="button"
              onClick={() => copy(row.value, row.key)}
              className="flex-shrink-0 min-w-[76px] px-3 py-2 text-xs rounded-md cursor-pointer bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-700 dark:text-gray-300"
            >
              {copied === row.key ? 'Copiado' : 'Copiar'}
            </button>
          </div>
        </div>
      ))}
      <p className="text-xs text-gray-500 dark:text-gray-400">Envía el enlace y el PIN al cliente por separado.</p>
    </div>
  );
}

PortalAccessCredentials.propTypes = {
  accessToken: PropTypes.string.isRequired,
  accessPin: PropTypes.string.isRequired,
};
